import React, { Suspense, lazy, useEffect, useState } from "react";
import "./App.css";
import Header from "./components/Header/index.js";
import Banner from "./components/Banner/Banner";
import useSunWestSuccessYears from './components/Utils/useSunWestSuccessYears.js';
import useSharedEquityLoanData from "./components/Utils/useSharedEquityLoanData.js";
import Shimmer from "./components/ShimmerUI/ShimmerUI.js";
import MediaQuery from "react-responsive";

const AngelAiWidget = lazy(() => import('./components/widgets/AngelAiWidget.js'));
const ClientFlexibility = lazy(() => import('./components/ClientFlexibility/Client.js'));
const WhatIsCribEquity = lazy(() => import("./components/whatIsCribEquity/index.js"));
const HowItWorks = lazy(() => import("./components/HowItWorks/index.js"));
const WhyChooseSunwest = lazy(() => import("./components/WhyChooseSunwest/WhyChooseSunwest.js"));
const Disclaimer = lazy(() => import("./components/Disclaimer/Disclaimer.js"))
const Footer = lazy(() => import("./components/Footer/Footer.js"))


export default function Home() {

  const data = useSharedEquityLoanData();
  const [showOtherComponents, setShowOtherComponents] = useState(false);
  const successYears = useSunWestSuccessYears();


  useEffect(() => {
    window.history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);  // Scroll to top on page refresh

    // Redirect /dscrheloc to /dscrheloc1to4units
    if (window.location.pathname.replace(/\/$/, '') === '/dscrheloc') {
      window.location.replace(window.location.origin + '/dscrheloc1to4units/');
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 50) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  if (data === null) {
    return <Shimmer />
  }

  const loadingStyle = {
    textAlign: 'center'
  };

  return (
    <>
      <Header fetchpriority="high" />

      <Suspense fallback={<div />}>
        <Banner fetchpriority="high" data={data} />
      </Suspense>

      <Suspense fallback={<div />}>
        <WhatIsCribEquity data={data} />
      </Suspense>
      <Suspense fallback={<div />}>
            <ClientFlexibility data={data} />
          </Suspense>
      <Suspense fallback={<div />}>
        <HowItWorks data={data} />
      </Suspense>

      <Suspense fallback={<div>loading...</div>}>
        <AngelAiWidget />
      </Suspense>
      {showOtherComponents && (
        <>
       
          <Suspense fallback={<div style={loadingStyle}>Loading...</div>}>

            <WhyChooseSunwest data={data} />
          </Suspense>
          {/* <Suspense fallback={<div />}>
            <LogoCarousel />
          </Suspense> */}

          {/* <Suspense fallback={<div style={loadingStyle}></div>}>
            <RealStories data={data} />
          </Suspense> */}

          <Suspense fallback={<div />}>
            <Disclaimer fetchpriority="low" data={data} />
          </Suspense>
          <Suspense fallback={<div />}>
            <Footer fetchpriority="low" />
          </Suspense>
        </>
      )}
    </>
  );
}

